// Deep import: the shared segment lives in a browser-safe, dependency-free leaf module, since the
// @civilgrid/utils barrel pulls Node-only modules into the client bundle.
import { EXPORT_HISTORY_TAB_SEGMENT } from '@civilgrid/utils/src/extract/constants';

/**
 * Route segments for the export tabs, named here so a rename can't leave a stale literal behind.
 *
 * The legacy segments stay listed because they are already out in the world: the extract emails link
 * to `/projects/:id/downloads`, and an unrecognised segment renders a blank tab rather than
 * redirecting, so those links need somewhere to land.
 */
export const EXPORT_TAB_ID = 'exports';

/** Search param naming where a link into the export tab came from, for its PostHog events. */
export const EXPORT_ENTRY_POINT_PARAM = 'from';
export const UTILITIES_EXPORTS_MENU_ENTRY_POINT = 'utilities_exports_menu';

/** Sourced from `utils` because the extract emails link here, and they are built in `jobs`. */
export const EXPORT_HISTORY_TAB_ID = EXPORT_HISTORY_TAB_SEGMENT;

/**
 * The export tab's own DOM node, which onboarding masks and points at. Mirrors the `tab-<id>-open`
 * id the project shell renders, so renaming the segment moves this with it.
 */
export const EXPORT_TAB_OPEN_SELECTOR = `#tab-${EXPORT_TAB_ID}-open`;

/** The export-history tab's own DOM node. Onboarding shares one step across both export tabs. */
export const EXPORT_HISTORY_TAB_OPEN_SELECTOR = `#tab-${EXPORT_HISTORY_TAB_ID}-open`;

const LEGACY_EXPORT_TAB_ID = 'new-download';
const LEGACY_EXPORT_HISTORY_TAB_ID = 'downloads';

/** Legacy segment → the tab it now lives at. */
const LEGACY_EXPORT_TAB_IDS: Record<string, string> = {
  [LEGACY_EXPORT_TAB_ID]: EXPORT_TAB_ID,
  [LEGACY_EXPORT_HISTORY_TAB_ID]: EXPORT_HISTORY_TAB_ID,
};

/** Where a legacy export segment should redirect, or undefined when the segment is current. */
export function resolveLegacyExportTabId(tabId: string | undefined): string | undefined {
  return tabId ? LEGACY_EXPORT_TAB_IDS[tabId] : undefined;
}
